import { ringDistance } from '../world/grid.js';
import { BOSS_SHARE_RANGE } from './boss.js';
import { killXp } from './progression.js';
/**
 * Parties (ADR 0032), as pure rules: how many, who shares a kill, how the
 * experience is split. The server keeps the parties themselves
 * (`PartyRegistry`); nothing here holds any.
 */
export const PARTY_MAX_SIZE = 5;
/** A member this far from the corpse, or further, is not in the fight: the boss's rule. */
export const PARTY_SHARE_RANGE = BOSS_SHARE_RANGE;
/**
 * Each member sharing a kill beyond the first adds this much to the whole.
 * Two players earn 55 % each: less than alone, but they kill faster than
 * one, so playing together pays without a party of five farming for free.
 */
export const PARTY_XP_BONUS_PER_MEMBER = 0.1;
/** An invitation not answered in this time lapses. */
export const PARTY_INVITE_TTL_MS = 30_000;
/**
 * A member who left the game keeps their seat this long: a reload, a zone
 * change or a short cut does not break the party.
 */
export const PARTY_OFFLINE_GRACE_MS = 5 * 60_000;
/**
 * Who shares a kill: the killer, always, and every other member present in
 * the zone within `PARTY_SHARE_RANGE` of the corpse, alive. `positions`
 * holds the members present in the zone and alive; one missing is elsewhere
 * or down. The killer comes first, the others in party order.
 */
export function partySharers(killerId, members, positions, corpse) {
    const sharers = [killerId];
    for (const id of members) {
        if (id === killerId)
            continue;
        const at = positions.get(id);
        if (at !== undefined && ringDistance(at, corpse) < PARTY_SHARE_RANGE)
            sharers.push(id);
    }
    return sharers;
}
/**
 * Experience each sharer earns, in the order of `levels`: the creature's
 * worth, raised by the party bonus, split evenly, then cut for each member
 * by their own level against the creature's (`killXp`) — a strong friend
 * earns little on weak prey, and takes nothing from the others.
 */
export function partyKillXp(xp, mobLevel, levels) {
    const count = levels.length;
    if (count === 0)
        return [];
    const share = (xp * (1 + PARTY_XP_BONUS_PER_MEMBER * (count - 1))) / count;
    return levels.map((level) => killXp(share, level, mobLevel));
}
//# sourceMappingURL=party.js.map